const screenSizes = {
    SMALL: 'small',
    LARGE: 'large'
};

export default screenSizes;
